export default __webpack_public_path__ + "static/manage-listings-page-a48f3ee2c4b26ce567f7a0b07af3110f.png";